// NT 2026.004: CNPJ pode ser alfanumerico (12 alfanumericos + 2 digitos do DV).
// Mesma mascara XX.XXX.XXX/XXXX-XX funciona para ambos.
export function formatCNPJ(cnpj?: string): string {
  if (!cnpj) return '';
  // Preserva letras (uppercase) + remove pontuacao.
  const d = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (d.length !== 14) return cnpj;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

export function formatCPF(cpf?: string): string {
  // CPF continua sendo numerico.
  const d = (cpf || '').replace(/\D/g, '');
  if (d.length !== 11) return cpf || '';
  return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatDoc(doc?: string): string {
  // Tenta CNPJ alfanumerico primeiro (preserva letras), senao CPF.
  if (doc) {
    const dUpper = doc.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (dUpper.length === 14) return formatCNPJ(dUpper);
    if (dUpper.length === 11 && /^\d+$/.test(dUpper)) return formatCPF(dUpper);
  }
  return doc || '';
}

export function formatCEP(cep?: string): string {
  // CEP continua numerico.
  const d = (cep || '').replace(/\D/g, '');
  if (d.length !== 8) return cep || '';
  return d.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatMoney(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return 'R$ 0,00';
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (typeof n !== 'number' || isNaN(n)) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
}

export function formatDate(iso?: string | null): string {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('pt-BR');
  } catch {
    return iso;
  }
}

export function formatDateTime(iso?: string | null): string {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString('pt-BR');
  } catch {
    return iso;
  }
}
